export const interviewEmailFields = [
  {
    key: "candidate_email_enabled",
    label: "Candidate Interview Emails",
    description: "Send interview invitations and details to candidates.",
  },
  {
    key: "panel_email_enabled",
    label: "Panel Member Interview Emails",
    description:
      "Send interview invitations and details to selected interview panel members.",
  },
  {
    key: "manager_email_enabled",
    label: "Manager/Recruiter Interview Emails",
    description: "Send interview notifications to managers and recruiters.",
  },
  {
    key: "interview_recording_attachment_enabled",
    label: "Attach Interview Call Recording",
    description:
      "When enabled, attach the selected candidate extension-call recording to interview emails. The backend selects the longest available recording and uses the latest recording when durations are equal. A recording is attached only when a valid recording URL and a matching candidate extension call record exist.",
  },
]

export const readInterviewEmailSettings = data =>
  Object.fromEntries(
    interviewEmailFields.map(({ key }) => {
      if (typeof data?.[key] !== "boolean")
        throw new Error(
          "The API returned incomplete interview email settings. Please reload."
        )
      return [key, data[key]]
    })
  )
